/**
 * Shared date formatting for Costs tab panels.
 */

import { formatDateTime } from '@/utils/format';

export function formatShortDate(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return iso;
  }
}

export const formatWhen = (iso: string): string =>
  formatDateTime(iso, { dateStyle: 'medium', timeStyle: 'short' });
